module.exports = require("@ember/object/promise-proxy-mixin");